import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IController, IPromise} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {Debugger} from "debug";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {gettextCatalog} from "angular-gettext";

const debug: Debugger = require('debug')('BekreftMobilnummerDialog');
const css = require('./bekreftMobilnummerDialog.scss');

export class BekreftMobilnummerDialog implements IController {

    static visBekreftMobilnummerDialog($mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon());
    }

    private static dialogKonfigurasjon(): angular.material.IDialogOptions {
        return {
            template: require('./bekreftMobilnummerDialog.html'),
            controller: BekreftMobilnummerDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            multiple: true //tillater at vi viser denne dialogen uten at eventuelle eksisterende dialoger lukkes
        };
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            GruppeRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            regNavn.md.$mdDialog,
            BekreftMobilnummerDialog
        ]
    }

    constructor(private kontekst: Kontekst, private gruppeRessurs: GruppeRessurs, private gettextCatalog: gettextCatalog, private $mdDialog: angular.material.IDialogService) {
    }

    lukk(){
        this.$mdDialog.hide();
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit(): void {
    }

    //hjelpemetoder

}
